// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import '../static/flexible'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js/dist/vue-fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'iIrwNamFMVzd6OLYas0yxF4K9Q4G0Pmj'
})

import axios from 'axios'
var interceptLogin = axios.create({
  baseURL:''
})

Vue.prototype.$http = interceptLogin

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueFullPage);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js